import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import cx from 'classnames';
import { withAdminModule } from '../../helpers/hoc/withAdminModule';
import FeatureFlags from '../../util/featureFlags';

import './SkinnyBanner.less';

export const SkinnyBannerView = ({ module }) => {
  const skinnyFeatureFlag = FeatureFlags.get('skinnyBannerRedesign');
  const transform = node => (node.type === 'tag' && (node.name !== 'strong' && node.name !== 'b')) ? null : '';
  const content = skinnyFeatureFlag ? ReactHtmlParser(module.link_label, { decodeEntities: true, transform }) : module.link_label;
  return (
    <div className={cx('col-xs-12 col-md-12 banner-promo-module', {
      'banner-promo-module--is-redesign': skinnyFeatureFlag,
    })}>
      <a href={module.link_path} rel="noopener noreferrer">
        <span>
          {content}
        </span>
      </a>
    </div>
  );
};

const isSkinnyBannerModule = module => module.title && module.title.startsWith('SkinnyBanner -');

export default withAdminModule(SkinnyBannerView, isSkinnyBannerModule);




// WEBPACK FOOTER //
// ./src/components/promotions/SkinnyBanner.jsx